import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "presentation-multi-page-form__checkboxes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_PresentationMainForm = _resolveComponent("PresentationMainForm")!

  return (_openBlock(), _createBlock(_component_PresentationMainForm, {
    countryId: _ctx.form.countryId,
    "onUpdate:countryId": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.countryId) = $event)),
    year: _ctx.form.year,
    "onUpdate:year": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.year) = $event)),
    countries: _ctx.countries,
    disabled: _ctx.disabled,
    loading: _ctx.isLoading,
    onSubmit: _ctx.onDownload
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CheckboxInput, {
          id: "export-potential",
          label: "Экспортный потенциал",
          modelValue: _ctx.form.isExportPotential,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isExportPotential) = $event)),
          disabled: _ctx.disabled || _ctx.isLoading
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_CheckboxInput, {
          id: "import-potential",
          label: "Импортный потенциал",
          modelValue: _ctx.form.isImportPotential,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.isImportPotential) = $event)),
          disabled: _ctx.disabled || _ctx.isLoading
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["countryId", "year", "countries", "disabled", "loading", "onSubmit"]))
}